/**
 * @generated SignedSource<<ab851506f4948723f00dd8855d654c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditCharacteristicActive_tenant$data = {
  readonly dId: any | null;
  readonly name: string;
  readonly vpmAccountId: number | null;
  readonly " $fragmentType": "EditCharacteristicActive_tenant";
};
export type EditCharacteristicActive_tenant$key = {
  readonly " $data"?: EditCharacteristicActive_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditCharacteristicActive_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditCharacteristicActive_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "f066ed4f85b42ab139d8b5dab7a53146";

export default node;
